import { z } from 'zod'
import {
  BuyerSchema, ConsigneeSchema, ConsignorSchema, SellerSchema,
} from 'features/declaration/models/schemas/tradersSchema'
import {
  AdditionalInformationSchema,
  AdditionalReferenceSchema,
  BooleanSchema, TransportEquipmentSchema,
  CountriesOfRoutingSchema,
  DepartureTransportMeansSchema, PassiveBorderTransportMeansSchema,
} from 'features/declaration/models/schemas/commonConsignmentSchemas'
import { AdditionalSupplyChainActorSchema } from 'features/declaration/additional-supply-chain-actor/models/schema'
import {
  PreviousDocumentData,
  PreviousDocumentSchema, SupportingDocumentData,
  SupportingDocumentSchema,
  TransportDocumentData,
  TransportDocumentSchema,
} from 'features/declaration/models/schemas/documentSchemas'
import ConsignmentItemSchema from 'features/declaration/consignment-item/models/schema'
import { PlaceOfAcceptanceSchema, PlaceOfDeliverySchema } from 'features/declaration/models/schemas/placesSchemas'

const HouseConsignmentSchema = z.object(
  {
    id: z.number().nullable(),
    deleted: z.boolean().optional(),
    sequenceNumber: z.number().nonnegative(),
    grossMass: z.number().min(0).refine((arg) => /^\d{1,11}(\.\d{1,3})?$/.exec(String(arg))),
    referenceNumberUCR: z.string(),
    securityIndicatorFromExportDeclaration: z.string(),
    transportChargesMethodOfPayment: z.string().nullable(),
    consignor: ConsignorSchema.nullable(),
    consignee: ConsigneeSchema.nullable(),

    countryOfDestination: z.string(),
    countryOfDispatch: z.string(),
    placeOfAcceptance: PlaceOfAcceptanceSchema,
    placeOfDelivery: PlaceOfDeliverySchema,
    buyer: BuyerSchema.optional(),
    seller: SellerSchema.optional(),
    containerIndicator: BooleanSchema.default('false'),

    additionalSupplyChainActor: z.array(AdditionalSupplyChainActorSchema),
    departureTransportMeans: z.array(DepartureTransportMeansSchema),
    previousDocument: z.array(PreviousDocumentSchema),
    supportingDocument: z.array(SupportingDocumentSchema),
    transportDocument: z.array(TransportDocumentSchema),
    additionalReference: z.array(AdditionalReferenceSchema),
    additionalInformation: z.array(AdditionalInformationSchema),
    consignmentItem: z.array(ConsignmentItemSchema),

    countriesOfRouting: z.array(CountriesOfRoutingSchema),
    passiveBorderTransportMeans: z.array(PassiveBorderTransportMeansSchema),
    transportEquipment: z.array(TransportEquipmentSchema),

    differentBuyer: z.boolean().default(false),
    differentSeller: z.boolean().default(false),
    differentCountriesOfRouting: z.boolean().default(false),
    differentPlaceOfAcceptance: z.boolean().default(false),
    differentPlaceOfDelivery: z.boolean().default(false),
  },
)
export type HouseConsignmentFormValues = z.infer<typeof HouseConsignmentSchema>

export type HouseConsignmentData =
  Omit<HouseConsignmentFormValues, 'transportDocument' | 'previousDocument' | 'supportingDocument'> & {
    transportDocument: TransportDocumentData[]
    previousDocument: PreviousDocumentData[]
    supportingDocument: SupportingDocumentData[]
  }

export default HouseConsignmentSchema
